igws-back-to-top {
  width: 50px;
  height: 50px;
  right: 32px;
  bottom: 92px;
  opacity: 0;
  visibility: hidden;
  position: fixed;
  cursor: pointer;
  border-radius: 25px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background: @back-to-top no-repeat;
  z-index: 9999;

  &.show {
    opacity: 1;
    visibility: visible;
  }
}

/* tablet breakpoint */
@media (max-width: @medium-breakpoint) {
  igws-back-to-top {
    right: 30px;
  }
}

/* mobile breakpoint */
@media (max-width: @small-breakpoint) {
  .ibgdpr igws-back-to-top {
    bottom: 160px; // to cater for the cookie consent on mobile
  }
}
